import { Layout as AntLayout } from "antd";
import styled from "styled-components";
import figure from "../../assets/figure1.png";
import Viewmovil2 from "../../assets/ic-ViewMovil2.png";

const { Content: AntContent } = AntLayout;
export const colors = {
  background: "#000054",
  blue: "#1E3799",
  green: " #00D3B0",
  red: "#FF1744",
  white: "#ffffff",
  whiteOpacity: "#ffffff66",
  grey: "#707070",
};
export const Layout = styled(AntLayout)`
  main {
  background: ${colors.background};
  }
  #page-wrap {
    height: 100%;
    overflow: auto;
    text-align: center;
    overflow: auto;
  }

  .bm-menu-wrap {
    right: 0px !important;
  }

  .bm-item {
    display: inline-block;

    /* Our sidebar item styling */
    text-decoration: none;
    margin-bottom: 10px;
    color: #d1d1d1;
    transition: color 0.2s;
  }

  .bm-item:hover {
    color: white;
  }

  .bm-burger-button {
    position: absolute;
    width: 30px;
    height: 22px;
    right: 36px;
    top: 27px;
  }

    @media (max-width: 608px) {
      .bm-burger-button {
        top: 22px;
        }
    }
  /* Color/shape of burger icon bars */
  .bm-burger-bars {
    background: #1e3799;
    border-radius: 10px;
    height: 10% !important;
  }

  /* Position and sizing of clickable cross button */
  .bm-cross-button {
    height: 24px;
    width: 24px;
  }

  /* Color/shape of close button cross */
  .bm-cross {
    background: #bdc3c7;
  }

  /* General sidebar styles */
  .bm-menu {
    padding: 2.5em 1.5em 0;
    font-size: 1.15em;
    width: inherit;
    background: #1b1464;
  }

  /* Morph shape necessary with bubble or elastic */
  .bm-morph-shape {
    fill: #373a47;
  }

  /* Wrapper for item list */
  .bm-item-list {
    color: #b8b7ad;
  }

  /* Styling of overlay */
  .bm-overlay {
    background: rgb(27, 20, 100) !important;
    opacity: 0.3 !important;
  }
  .text-big {
    font-size: 30px;
    color: #fff;
  }
  }
`;

export const Content = styled(AntContent)`
padding-top: 20px;
@media (max-width: 608px) {
padding-top: 0;
}
  .Row-Contentbg {
    min-height: 500px;
    display: flex;
    justify-content: center;
    padding: 0;
  }
  .input-time {
    padding: 8px 19px;
    border-radius: 40px;
    color: ${colors.blue};
    font-size: 16px;
    font-weight: bold;
    border: none;
    &[type="time"]::-webkit-calendar-picker-indicator {
      filter: invert(26%) sepia(87%) saturate(532%) hue-rotate(197deg)
        brightness(89%) contrast(92%);
    }
  }
  .Col-contentImg {
    z-index: 0;
    position: relative;
    padding: 0 60px;
    img {
      min-width: 50%;
      height: 500px;
      width: 1440px;
      object-fit: cover;
    }
  }

  .Col-menu--content {
    background: linear-gradient(to right, ${colors.blue}, ${colors.green});
    border-radius: 70px;
    min-width: 50%;
    min-height: 90px;
    top: 560px;
    display: flex;
    justify-content: center;
    padding: 24px 36px 14px;
    position: absolute;
    margin: 0 40px;
    align-items: center;
    z-index: 10;

    @media (min-width: 1800px) {
      min-width: 926px;
      max-width: 926px;
    }
  }

  .Row-Select--menu {
    align-items: center;
    justify-content: center;

    .ant-select-selector {
      background: ${colors.white};
      height: 40px;
      padding-top: 4px;
      border-radius: 40px;
      color: ${colors.blue};
      border-color: ${colors.white};
      font-family: "Rubik", sans-serif;
      font-size: 16px;
      font-weight: 600;
    }
    .ant-select-selection-item {
      font-weight: 600;
      color: ${colors.blue};
    }
    .Col-content--select {
      height: 52px;
    }

    .ant-picker {
      background: ${colors.white};
      border-color: ${colors.white};
      height: 40px;
      padding-top: 4px;
      border-radius: 40px;
      min-width: 50%;
      width: 148px;
    }

    .ant-picker-input > input {
      font-size: 16px;
      font-family: "Rubik", sans-serif;
      color: ${colors.blue};
      font-weight: 600;
    }
    .ant-select-selection-placeholder {
      color: ${colors.blue} !important;
      font-weight: 600;
    }
    .ant-picker-suffix {
      color: ${colors.blue} !important;
      font-weight: 600;
    }
  }

  .Col-Select--Title {
    top: 150px;
    left: 90px;
    display: flex;
    position: absolute;
    z-index: 100;
    h1 {
      line-height: 50px;
      font-weight: 600;
      color: #fff;
      font-family: "Rubik", sans-serif;
      font-size: 60px;
      z-index: 2;
    }
  }

  .firstSelect {
    width: 180px;
    min-width: 50%;
  }

  .selectMenu {
    width: 148px;
    min-width: 50%;
    border-radius: 10px;
  }

  .activityTypeSelect {
    width: 180px;
  }
  p {
    font-family: "Rubik", sans-serif;
    line-height: 1.3;
  }
  .buttonSearch {
    background: ${colors.blue};
    width: 120px;
    border-radius: 40px;
    border-color: ${colors.blue};
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    height: 40px;
  }

  .textTitle::after {
    content: url(${figure});
    display: block;
    height: 20px;
    width: 100px;
    position: absolute;
    top: 81px;
    margin-left: 150px;
  }
  .contact {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .wpp {
    position: absolute;
    bottom: 50px;
    transform: translate(-50%);
    left: 50%;
  }
  .buttonws {
    box-shadow: 0 36px 30px -24px rgb(0 211 176 / 55%);
    background: #00d3b0;
    color: #fff;
    border-radius: 40px;
    width: 240px;
    height: 40px;
    font-size: 20px;
    font-family: "Roboto", sans-serif;
    border-color: #00d3b0;
    font-weight: 900;
    z-index: 10;
    display: grid;
    padding: 0 15px;
    justify-content: center;
    align-content: center;
  }
  .ant-picker-time-panel-column::after {
    content: ""; /* Asegúrate de esto */
    display: block;
    height: 0 !important; /* Usa !important si antd lo sobrescribe */
  }
  .Row-titleIcons {
    margin-top: 130px;
  }

  .Col-titleIcons {
    display: grid;
    justify-content: center;
    p {
      font-family: "Rubik", sans-serif;
      font-weight: 600;
      font-size: 36px;
      text-align: center;
      margin-bottom: 0px;
    }
  }

  .Row-infoic {
    background: #ffff;
    min-height: 700px;
  }

  .Col-infoic--img {
    display: flex;
  }

  .Col-infoic--icancha {
    padding-top: 140px;

    h1 {
      font-weight: 600;
      font-size: 36px;
      color: #1e3799;
      font-family: "Rubik", sans-serif;
    }

    h2 {
      font-weight: 400;
      font-size: 26px;
      color: #1e3799;
      font-family: "Rubik", sans-serif;
      line-height: 26px;
      margin-bottom: 20px;
    }

    p {
      font-weight: 700;
      font-size: 18px;
      color: #a1a1a1;
      font-family: "Roboto", sans-serif;
      line-height: 24px;
    }

    strong {
      color: #1e3799;
    }
  }

  .Row-info {
    background: #1533a7;
    justify-content: center;
  }

  .Col-info--content {
    margin-top: 80px;
    margin-bottom: 80px;
    padding: 0 60px;
  }

  .Row--info--content-text {
    justify-content: center;

    h1 {
      color: #fff;
      font-size: 36px;
      font-weight: 600;
      font-family: "Rubik", sans-serif;
      line-height: 40px;
      text-align: center;
    }

    p {
      color: #fff;
      font-size: 26px;
      font-weight: 400;
      font-family: "Rubik", sans-serif;
      margin: 0px;
      text-align: center;
    }
  }

  .Row-infoapp {
    background: #ffff;
    height: 691px;
  }

  .Row-infoapp--contenttext {
    justify-content: center;
    margin-left: 30px;
    margin-top: 400px;
  }

  .Col-infoapp--text {
    h1 {
      font-family: "Rubik", sans-serif;
      font-size: 36px;
      font-weight: 600;
      line-height: 43px;
      text-align: left;
      color: #1e3799;
      margin-bottom: 0px;
    }

    p {
      font-family: "Rubik", sans-serif;
      font-size: 28px;
      font-weight: 600;
      line-height: 33.18px;
      text-align: left;
      color: #3742fa;
    }
  }

  .Col-infoapp-image {
    display: flex;
    justify-content: flex-end;
  }

  #page-wrap {
    height: 100%;
    overflow: auto;
    text-align: center;
    overflow: auto;
    //top: 45%;
    //position: relative;
  }
  .ant-select-arrow {
    color: ${colors.background};
  }
  .Row-banner1 {
    padding-top: 100px;
  }
  .bm-menu-wrap {
    right: 0px !important;
  }

  .bm-item {
    display: inline-block;

    /* Our sidebar item styling */
    text-decoration: none;
    margin-bottom: 10px;
    color: #d1d1d1;
    transition: color 0.2s;
  }

  .bm-item:hover {
    color: white;
  }

  .bm-burger-button {
    position: absolute;
    width: 30px;
    height: 22px;
    right: 36px;
    top: 27px;
  }
    @media (max-width: 608px) {
      .bm-burger-button {
        top: 22px;
        }
    }
  /* Color/shape of burger icon bars */
  .bm-burger-bars {
    background: #1e3799;
    border-radius: 10px;
    height: 10% !important;
  }

  /* Position and sizing of clickable cross button */
  .bm-cross-button {
    height: 24px;
    width: 24px;
  }

  /* Color/shape of close button cross */
  .bm-cross {
    background: #bdc3c7;
  }

  /* General sidebar styles */
  .bm-menu {
    padding: 2.5em 1.5em 0;
    font-size: 1.15em;
    width: inherit;
    background: #1b1464;
  }

  /* Morph shape necessary with bubble or elastic */
  .bm-morph-shape {
    fill: #373a47;
  }

  /* Wrapper for item list */
  .bm-item-list {
    color: #b8b7ad;
  }

  /* Styling of overlay */
  .bm-overlay {
    background: rgb(27, 20, 100) !important;
    opacity: 0.3 !important;
  }

  @media (max-width: 992px) {
    .Col-Select--Title {
      top: 100px;
    }
    .wpp {
      bottom: 30px;
    }
    .Col-menu--content {
      top: 500px;
      border-radius: 10px;
    }
    .Row-banner1 {
      padding-top: 110px;
    }
    .col-1 {
      width: 25%;
      .ant-select {
        width: 100% !important;
      }
    }
    .col-2 {
      width: 25%;
      .ant-select {
        width: 100% !important;
      }
    }
    .col-3 {
      width: 25%;
      .ant-select {
        width: 100% !important;
      }
    }
    .col-4 {
      width: 25%;
      .ant-select {
        width: 100% !important;
      }
    }
    .col-5 {
      width: 25%;
      .ant-picker {
        width: 100%;
      }
    }
    .col-6 {
      width: 25%;
      .ant-picker {
        width: 100%;
      }
    }
    .col-7 {
      width: 50%;
      .buttonSearch {
        width: 100%;
      }
    }
  }

  @media (max-width: 992px) {
    .Col-menu--content {
      top: 530px;
    }
    .Row-banner1 {
      padding-top: 200px;
    }
    .col-1 {
      width: 50%;
    }
    .col-2 {
      width: 50%;
    }
    .col-3 {
      width: 50%;
    }
    .col-5 {
      width: 50%;
    }
    .col-7 {
      width: 100%;
    }
  }

  @media (max-width: 992px) {
    .Col-Select--Title {
      left: 30px;
      padding-right: 30px;
      h1 {
        font-size: 48px;
      }
      .text-big {
        font-size: 24px;
      }
    }

    .Col-contentImg {
      padding: 0;
    }
    .wpp {
      bottom: 30px;
    }
    .Col-Select--Title {
      top: 80px;
    }
    .contact {
      bottom: 10px;
    }

    .Col-infoic--icancha {
      padding-top: 0px;
      padding-bottom: 90px;
    }

    .Row-infoapp {
      height: auto;
      flex-direction: column-reverse;
    }

    .Row-infoapp--contenttext {
      margin-top: 0px;
      margin-bottom: 100px;
    }

    .Col-infoapp-image {
      background: url(${Viewmovil2}) no-repeat;
      background-size: auto;
      background-position-x: right;
      height: 600px;
      margin-top: 130px;

      img {
        visibility: collapse;
      }
    }

    @media (max-width: 770px) {
      .Col-menu--content {
        top: 400px;
        margin: 0 40px;
      }
      .contact {
        bottom: 0px;
      }
      .Row-banner1 {
        padding-top: 220px;
      }
      .col-1 {
        width: 100%;
      }
      .col-2 {
        width: 100%;
      }
      .col-3 {
        width: 50%;
      }
      .col-5 {
        width: 50%;
      }
      .col-7 {
        width: 100%;
      }
      // .Row-Select--menu {
      //   .ant-select-selector {
      //     background-color: ${colors.whiteOpacity}!important;
      //     color: ${colors.white};
      //     border-color: ${colors.white};
      //   }
      //   .ant-select-selection-item {
      //     color: ${colors.white};
      //   }

      //   .ant-picker {
      //     background-color: ${colors.whiteOpacity}!important;
      //     border-color: ${colors.white};
      //   }

      //   .ant-picker-input > input {
      //     color: ${colors.white}!important;
      //   }
      //   .ant-select-selection-placeholder {
      //     color: ${colors.white} !important;
      //   }
      //   .ant-picker-suffix {
      //     color: ${colors.white} !important;
      //   }
      // }
    }

    @media (max-width: 650px) {
      .Col-menu--content {
        margin: 0 20px;
      }
    }
    @media (max-width: 608px) {
      .bm-burger-button {
        top: 22px;
      }
      .wpp {
        bottom: 50px;
      }
      .contact {
        bottom: 20px;
      }
      .Row-banner1 {
        padding-top: 270px;
      }
      .Col-menu--content {
        padding: 40px 20px;
      }

      .Row-Select--menu {
        .col-1,
        .col-2,
        .col-7 {
          width: 100% !important;
        }

        .col-3,
        .col-5 {
          width: 50% !important;
        }

        .firstSelect {
          width: 100% !important;
        }

        .selectMenu {
          width: 100% !important;
        }

        .buttonSearch {
          width: 100%;
        }

        .ant-picker {
          width: 100% !important;
        }
      }

      .Col-Select--Title {
        h1 {
          font-size: 40px;
          line-height: 40px;
        }
      }
    }

    @media (max-width: 576px) {
      .Col-titleIcons {
        p {
          font-size: 26px;
        }
      }
      .contact {
        bottom: 0px;
      }
      .textTitle::after {
        top: 58px;
        margin-left: 82px;
      }

      .Row--info--content-text {
        h1 {
          font-size: 32px;
          margin-bottom: 30px;
        }
        p {
          font-size: 22px;
        }
      }

      .Col-infoapp--text {
        h1 {
          font-size: 32px;
        }

        p {
          font-size: 24px;
        }
      }
    }
    @media (max-width: 410px) {
  .Row-Contentbg {
    min-height: 550px;
  }
      .Col-menu--content {
        top: 430px;
        margin: 0 30px;
      }
      .Row-Select--menu {
      row-gap: 8px;
        .col-1,
        .col-2,
        .col-7 {
          width: 100% !important;
        }

        .col-3,
        .col-5 {
          width: 50% !important;
        }

        .firstSelect {
          width: 100% !important;
        }

        .selectMenu {
          width: 100% !important;
        }

        .buttonSearch {
          width: 100%;
        }

        .ant-picker {
          width: 100% !important;
        }
      
    }
    @media (max-width: 382px) {
      .Col-menu--content {
        top: 450px;
        margin: 0 30px;
      }
    }
  }
`;
